export const MAX_OPTIONS = 60;

export const DEBOUNCED_SEARCH_QUERY_TIME = 150;
